import styled from 'styled-components';

export const Card = styled.div`
  position: relative;
  display: flex;
  gap: 12px;
  padding: 12px 44px 12px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  cursor: pointer;
`;

export const Thumb = styled.div`
  flex: 0 0 88px;
  width: 88px;
  height: 88px;
  border-radius: 8px;
  background: #f5f5f5;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  font-size: 28px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Brand = styled.div`
  font-size: 13px;
  color: #8c8c8c;
  overflow-wrap: anywhere;
`;

export const Model = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #262626;
  overflow-wrap: anywhere;
`;

export const PriceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;

  .ant-tag {
    margin: 0;
  }
`;

export const Meta = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
  overflow-wrap: anywhere;
`;

export const MenuButton = styled.div`
  position: absolute;
  top: 4px;
  right: 0;

  .ant-btn {
    width: 44px;
    height: 44px;
  }
`;
